import { Link } from 'react-router-dom';

interface GameCardProps {
  id: string;
  name: string;
  category: string;
  image: string;
  rating: number;
  players: string;
  isHot?: boolean;
  isNew?: boolean;
  categorySlug?: string;
}

export default function GameCard({ id, name, category, image, rating, players, isHot, isNew, categorySlug }: GameCardProps) {
  return (
    <Link
      to={categorySlug ? `/category/${categorySlug}` : `/category/${category}`}
      className="group block bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all hover:scale-[1.02]"
    >
      <div className="relative w-full aspect-[3/2] overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute top-2 left-2 flex gap-1.5">
          {isHot && (
            <span className="px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
              热门
            </span>
          )}
          {isNew && (
            <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
              新品
            </span>
          )}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center pb-3">
          <span className="text-white text-sm font-medium whitespace-nowrap">立即试玩</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-base text-foreground-900 mb-1.5">{name}</h3>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-xs text-accent-500"></i>
            <span className="text-xs text-foreground-600">{rating}</span>
          </div>
          <span className="text-xs text-foreground-500">{players} 玩家</span>
        </div>
      </div>
    </Link>
  );
}